import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Offers = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <div className="bg-[#FAF7F2] md:px-[120px] p-[20px] md:pt-[60px] md:pb-[20px] gap-[16px] flex items-center">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="hover:bg-gray-100 rounded-full p-1 shrink-0"
          aria-label="Go back"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_offers_back)">
              <path d="M5 12H19" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M5 12L11 18" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M5 12L11 6" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_offers_back">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
        <h1 className="text-[20px] font-medium text-black tracking-[-1px]">Offers</h1>
      </div>

      <div className="md:px-[120px] p-[20px] md:py-[20px] flex flex-col gap-[16px] pb-10 w-full">
        <div className="bg-white rounded-[16px] p-[32px] md:p-[48px] shadow-sm border border-[#E5E3DF] text-center">
          <p className="text-[13px] uppercase tracking-wider text-[#FF5E4C] mb-3">Book For Paws</p>
          <h2 className="text-[20px] md:text-[22px] font-medium text-black tracking-[-0.02em] mb-3">
            Coming soon
          </h2>
          <p className="text-[14px] md:text-[15px] text-[#5c5c5c] leading-[1.6] max-w-md mx-auto mb-6">
            Exclusive deals on stays and events are on the way. Check back soon.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/stays"
              className="inline-flex items-center justify-center rounded-[14px] bg-black px-6 py-3 text-[14px] font-medium text-white hover:bg-gray-800 transition-colors"
            >
              Browse stays
            </Link>
            <Link
              to="/events"
              className="inline-flex items-center justify-center rounded-[14px] border border-[#d9d9d9] px-6 py-3 text-[14px] font-medium text-black hover:bg-black/5 transition-colors"
            >
              See events
            </Link>
          </div>
        </div>

        <div className="bg-white rounded-[16px] p-[20px] md:p-[24px] shadow-sm border border-gray-100">
          <p className="text-[13px] text-[#8c8c8c] leading-relaxed text-center">
            Questions? Reach out via{' '}
            <Link to="/help" className="text-[#FF5E4C] font-medium hover:underline">
              Customer Support
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default Offers;
